import { AggregatedView } from "src/components/viewers/SheetsViewerV2/hooks/useSheetsAggregatedView";
import { CROSSHAIR_CURSOR } from "src/components/viewers/SheetsViewerV2/SheetsViewerV2.config";

export abstract class AbstractToolWithOverlay extends Autodesk.Viewing.ToolInterface {

  protected constructor(
    readonly viewer: AggregatedView["viewer"],
    readonly snapper: Autodesk.Viewing.Extensions.Snapping.Snapper,
    readonly overlayId: string
  ) {
    super();

    delete (this as any).activate;
    delete (this as any).deactivate;
  }

  getCursor(): string {
    return CROSSHAIR_CURSOR;
  }

  activate(name: string, viewerApi?: Autodesk.Viewing.GuiViewer3D) {
    this.snapper.activate();
    const callback = () => {
      this.clear(viewerApi);
      viewerApi?.removeEventListener(
        Autodesk.Viewing.MODEL_UNLOADED_EVENT,
        callback
      );
    };

    viewerApi?.addEventListener(
      Autodesk.Viewing.MODEL_UNLOADED_EVENT,
      callback
    );
  }

  deactivate() {
    this.snapper.deactivate();
    this.clear();
  }

  clear(viewer = this.viewer) {
    viewer.impl.clearOverlay(this.overlayId);
    viewer.impl.invalidate(true, true, true);
  }

}